import { FunctionalGroup } from "@types";

export const getFunctionalGroupOptions = (
  functionalGroups: FunctionalGroup[] | undefined
) => (functionalGroups ?? []).map((functionalGroup) => functionalGroup.id);

export const getFunctionalGroupLabelMap = (
  functionalGroups: FunctionalGroup[] | undefined
): Record<string, string> =>
  Object.fromEntries(
    (functionalGroups ?? []).map((functionalGroup) => [
      functionalGroup.id,
      `${functionalGroup.name} (${functionalGroup.acronym})`,
    ])
  );
